/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */
import type {
  CreateWithdrawRequestInput,
  GetWalletDepositCoinAddress200,
  GetWalletDepositCoinAddress401,
  GetWalletDepositCoinAddress404,
  GetWalletDepositCoinAddressParams,
  GetWalletDepositCoinNetworks200,
  GetWalletDepositCoinNetworks401,
  GetWalletDepositCoinNetworks404,
  GetWalletHistory200,
  GetWalletHistory401,
  GetWalletHistoryId200,
  GetWalletHistoryId401,
  GetWalletHistoryId404,
  GetWalletHistoryParams,
  GetWalletPortfolio200,
  GetWalletPortfolio401,
  GetWalletPortfolioCoin200,
  GetWalletPortfolioCoin401,
  GetWalletPortfolioCoin404,
  GetWalletSummary200,
  GetWalletSummary401,
  GetWalletWithdrawCoinNetworks200,
  GetWalletWithdrawCoinNetworks401,
  GetWalletWithdrawCoinNetworks404,
  GetWalletWithdrawRequestId200,
  GetWalletWithdrawRequestId401,
  GetWalletWithdrawRequestId404,
  GetWalletWithdrawRequests200,
  GetWalletWithdrawRequests401,
  GetWalletWithdrawRequestsParams,
  PostWalletWithdraw201,
  PostWalletWithdraw400,
  PostWalletWithdraw401,
  PostWalletWithdraw404,
  PostWalletWithdrawQuote200,
  PostWalletWithdrawQuote400,
  PostWalletWithdrawQuote401,
  PostWalletWithdrawQuote404,
  PostWalletWithdrawQuote503,
  WithdrawQuoteInput
} from '../../models';

import { customFetch } from '../../mutator/customFetch';

/**
 * Retorna o resumo consolidado da wallet do usuário autenticado, incluindo saldo total, PNL em USD, PNL percentual e variação 24h. Todos os valores são strings decimais.
 * @summary Get wallet summary
 */
export type getWalletSummaryResponse200 = {
  data: GetWalletSummary200
  status: 200
}

export type getWalletSummaryResponse401 = {
  data: GetWalletSummary401
  status: 401
}

export type getWalletSummaryResponseSuccess = (getWalletSummaryResponse200) & {
  headers: Headers;
};
export type getWalletSummaryResponseError = (getWalletSummaryResponse401) & {
  headers: Headers;
};

export type getWalletSummaryResponse = (getWalletSummaryResponseSuccess | getWalletSummaryResponseError)

export const getGetWalletSummaryUrl = () => {


  

  return `https://api.wedofi.com/wallet/summary`
}

export const getWalletSummary = async ( options?: RequestInit): Promise<getWalletSummaryResponse> => {
  
  return customFetch<getWalletSummaryResponse>(getGetWalletSummaryUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna o endereço de depósito on-chain da wallet do usuário autenticado para a coin e rede informadas.
 * @summary Get deposit address
 */
export type getWalletDepositCoinAddressResponse200 = {
  data: GetWalletDepositCoinAddress200
  status: 200
}

export type getWalletDepositCoinAddressResponse401 = {
  data: GetWalletDepositCoinAddress401
  status: 401
}

export type getWalletDepositCoinAddressResponse404 = {
  data: GetWalletDepositCoinAddress404
  status: 404
}

export type getWalletDepositCoinAddressResponseSuccess = (getWalletDepositCoinAddressResponse200) & {
  headers: Headers;
};
export type getWalletDepositCoinAddressResponseError = (getWalletDepositCoinAddressResponse401 | getWalletDepositCoinAddressResponse404) & {
  headers: Headers;
};

export type getWalletDepositCoinAddressResponse = (getWalletDepositCoinAddressResponseSuccess | getWalletDepositCoinAddressResponseError)

export const getGetWalletDepositCoinAddressUrl = (coin: string,
    params: GetWalletDepositCoinAddressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/wallet/deposit/${coin}/address?${stringifiedParams}` : `https://api.wedofi.com/wallet/deposit/${coin}/address`
}

export const getWalletDepositCoinAddress = async (coin: string,
    params: GetWalletDepositCoinAddressParams, options?: RequestInit): Promise<getWalletDepositCoinAddressResponse> => {
  
  return customFetch<getWalletDepositCoinAddressResponse>(getGetWalletDepositCoinAddressUrl(coin,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna a lista de redes/chains disponíveis para depósito on-chain da coin informada, com nome amigável e valor mínimo de depósito.
 * @summary Listar redes de depósito disponíveis para uma coin
 */
export type getWalletDepositCoinNetworksResponse200 = {
  data: GetWalletDepositCoinNetworks200
  status: 200
}

export type getWalletDepositCoinNetworksResponse401 = {
  data: GetWalletDepositCoinNetworks401
  status: 401
}

export type getWalletDepositCoinNetworksResponse404 = {
  data: GetWalletDepositCoinNetworks404
  status: 404
}

export type getWalletDepositCoinNetworksResponseSuccess = (getWalletDepositCoinNetworksResponse200) & {
  headers: Headers;
};
export type getWalletDepositCoinNetworksResponseError = (getWalletDepositCoinNetworksResponse401 | getWalletDepositCoinNetworksResponse404) & {
  headers: Headers;
};

export type getWalletDepositCoinNetworksResponse = (getWalletDepositCoinNetworksResponseSuccess | getWalletDepositCoinNetworksResponseError)

export const getGetWalletDepositCoinNetworksUrl = (coin: string,) => {


  

  return `https://api.wedofi.com/wallet/deposit/${coin}/networks`
}

export const getWalletDepositCoinNetworks = async (coin: string, options?: RequestInit): Promise<getWalletDepositCoinNetworksResponse> => {
  
  return customFetch<getWalletDepositCoinNetworksResponse>(getGetWalletDepositCoinNetworksUrl(coin),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna a lista de redes/chains com saque on-chain habilitado para a coin informada, com taxa, valores mínimo/máximo e precisão decimal.
 * @summary Listar redes de saque disponíveis para uma coin
 */
export type getWalletWithdrawCoinNetworksResponse200 = {
  data: GetWalletWithdrawCoinNetworks200
  status: 200
}

export type getWalletWithdrawCoinNetworksResponse401 = {
  data: GetWalletWithdrawCoinNetworks401
  status: 401
}

export type getWalletWithdrawCoinNetworksResponse404 = {
  data: GetWalletWithdrawCoinNetworks404
  status: 404
}

export type getWalletWithdrawCoinNetworksResponseSuccess = (getWalletWithdrawCoinNetworksResponse200) & {
  headers: Headers;
};
export type getWalletWithdrawCoinNetworksResponseError = (getWalletWithdrawCoinNetworksResponse401 | getWalletWithdrawCoinNetworksResponse404) & {
  headers: Headers;
};

export type getWalletWithdrawCoinNetworksResponse = (getWalletWithdrawCoinNetworksResponseSuccess | getWalletWithdrawCoinNetworksResponseError)

export const getGetWalletWithdrawCoinNetworksUrl = (coin: string,) => {


  

  return `https://api.wedofi.com/wallet/withdraw/${coin}/networks`
}

export const getWalletWithdrawCoinNetworks = async (coin: string, options?: RequestInit): Promise<getWalletWithdrawCoinNetworksResponse> => {
  
  return customFetch<getWalletWithdrawCoinNetworksResponse>(getGetWalletWithdrawCoinNetworksUrl(coin),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Calcula a taxa da rede e o total a ser debitado (`amount + withdrawFee`) sem persistir nem mover saldo. Aplica as mesmas validações do saque real (destino permitido, limites da rede), então serve para antecipar as recusas antes de o usuário confirmar.
 * @summary Simular saque on-chain
 */
export type postWalletWithdrawQuoteResponse200 = {
  data: PostWalletWithdrawQuote200
  status: 200
}

export type postWalletWithdrawQuoteResponse400 = {
  data: PostWalletWithdrawQuote400
  status: 400
}

export type postWalletWithdrawQuoteResponse401 = {
  data: PostWalletWithdrawQuote401
  status: 401
}

export type postWalletWithdrawQuoteResponse404 = {
  data: PostWalletWithdrawQuote404
  status: 404
}

export type postWalletWithdrawQuoteResponse503 = {
  data: PostWalletWithdrawQuote503
  status: 503
}

export type postWalletWithdrawQuoteResponseSuccess = (postWalletWithdrawQuoteResponse200) & {
  headers: Headers;
};
export type postWalletWithdrawQuoteResponseError = (postWalletWithdrawQuoteResponse400 | postWalletWithdrawQuoteResponse401 | postWalletWithdrawQuoteResponse404 | postWalletWithdrawQuoteResponse503) & {
  headers: Headers;
};

export type postWalletWithdrawQuoteResponse = (postWalletWithdrawQuoteResponseSuccess | postWalletWithdrawQuoteResponseError)

export const getPostWalletWithdrawQuoteUrl = () => {


  

  return `https://api.wedofi.com/wallet/withdraw/quote`
}

export const postWalletWithdrawQuote = async (withdrawQuoteInput: WithdrawQuoteInput, options?: RequestInit): Promise<postWalletWithdrawQuoteResponse> => {
  
  return customFetch<postWalletWithdrawQuoteResponse>(getPostWalletWithdrawQuoteUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      withdrawQuoteInput,)
  }
);}
  

/**
 * Persiste uma solicitação de saque em estado `PENDING` e retorna o `id` do registro. A execução assíncrona (transfer sub→main → submitWithdrawal → confirmação on-chain) é tratada por workers — acompanhe pelo endpoint `GET /wallet/withdraw/request/{id}`.
 * @summary Registrar solicitação de saque on-chain
 */
export type postWalletWithdrawResponse201 = {
  data: PostWalletWithdraw201
  status: 201
}

export type postWalletWithdrawResponse400 = {
  data: PostWalletWithdraw400
  status: 400
}

export type postWalletWithdrawResponse401 = {
  data: PostWalletWithdraw401
  status: 401
}

export type postWalletWithdrawResponse404 = {
  data: PostWalletWithdraw404
  status: 404
}

export type postWalletWithdrawResponseSuccess = (postWalletWithdrawResponse201) & {
  headers: Headers;
};
export type postWalletWithdrawResponseError = (postWalletWithdrawResponse400 | postWalletWithdrawResponse401 | postWalletWithdrawResponse404) & {
  headers: Headers;
};

export type postWalletWithdrawResponse = (postWalletWithdrawResponseSuccess | postWalletWithdrawResponseError)

export const getPostWalletWithdrawUrl = () => {


  

  return `https://api.wedofi.com/wallet/withdraw`
}

export const postWalletWithdraw = async (createWithdrawRequestInput: CreateWithdrawRequestInput, options?: RequestInit): Promise<postWalletWithdrawResponse> => {
  
  return customFetch<postWalletWithdrawResponse>(getPostWalletWithdrawUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createWithdrawRequestInput,)
  }
);}
  

/**
 * Retorna o estado atual da solicitação de saque (status, rede, txHash, confirmações, etc.).
 * @summary Consultar status de uma solicitação de saque
 */
export type getWalletWithdrawRequestIdResponse200 = {
  data: GetWalletWithdrawRequestId200
  status: 200
}

export type getWalletWithdrawRequestIdResponse401 = {
  data: GetWalletWithdrawRequestId401
  status: 401
}

export type getWalletWithdrawRequestIdResponse404 = {
  data: GetWalletWithdrawRequestId404
  status: 404
}

export type getWalletWithdrawRequestIdResponseSuccess = (getWalletWithdrawRequestIdResponse200) & {
  headers: Headers;
};
export type getWalletWithdrawRequestIdResponseError = (getWalletWithdrawRequestIdResponse401 | getWalletWithdrawRequestIdResponse404) & {
  headers: Headers;
};

export type getWalletWithdrawRequestIdResponse = (getWalletWithdrawRequestIdResponseSuccess | getWalletWithdrawRequestIdResponseError)

export const getGetWalletWithdrawRequestIdUrl = (id: string,) => {


  

  return `https://api.wedofi.com/wallet/withdraw/request/${id}`
}

export const getWalletWithdrawRequestId = async (id: string, options?: RequestInit): Promise<getWalletWithdrawRequestIdResponse> => {
  
  return customFetch<getWalletWithdrawRequestIdResponse>(getGetWalletWithdrawRequestIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna a lista paginada das solicitações de saque do usuário autenticado, ordenadas por `createdAt` decrescente. Filtro opcional por `status`.
 * @summary Listar solicitações de saque do usuário
 */
export type getWalletWithdrawRequestsResponse200 = {
  data: GetWalletWithdrawRequests200
  status: 200
}

export type getWalletWithdrawRequestsResponse401 = {
  data: GetWalletWithdrawRequests401
  status: 401
}

export type getWalletWithdrawRequestsResponseSuccess = (getWalletWithdrawRequestsResponse200) & {
  headers: Headers;
};
export type getWalletWithdrawRequestsResponseError = (getWalletWithdrawRequestsResponse401) & {
  headers: Headers;
};

export type getWalletWithdrawRequestsResponse = (getWalletWithdrawRequestsResponseSuccess | getWalletWithdrawRequestsResponseError)

export const getGetWalletWithdrawRequestsUrl = (params?: GetWalletWithdrawRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/wallet/withdraw/requests?${stringifiedParams}` : `https://api.wedofi.com/wallet/withdraw/requests`
}

export const getWalletWithdrawRequests = async (params?: GetWalletWithdrawRequestsParams, options?: RequestInit): Promise<getWalletWithdrawRequestsResponse> => {
  
  return customFetch<getWalletWithdrawRequestsResponse>(getGetWalletWithdrawRequestsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna a lista de ativos do portfólio do usuário autenticado, incluindo todos os ativos disponíveis para depósito (mesmo sem saldo). A lista vem ordenada por valor total em USD decrescente. Todos os valores são strings decimais, para não perder saldos pequenos em notação científica.
 * @summary List wallet portfolio
 */
export type getWalletPortfolioResponse200 = {
  data: GetWalletPortfolio200
  status: 200
}

export type getWalletPortfolioResponse401 = {
  data: GetWalletPortfolio401
  status: 401
}

export type getWalletPortfolioResponseSuccess = (getWalletPortfolioResponse200) & {
  headers: Headers;
};
export type getWalletPortfolioResponseError = (getWalletPortfolioResponse401) & {
  headers: Headers;
};

export type getWalletPortfolioResponse = (getWalletPortfolioResponseSuccess | getWalletPortfolioResponseError)

export const getGetWalletPortfolioUrl = () => {


  

  return `https://api.wedofi.com/wallet/portfolio`
}

export const getWalletPortfolio = async ( options?: RequestInit): Promise<getWalletPortfolioResponse> => {
  
  return customFetch<getWalletPortfolioResponse>(getGetWalletPortfolioUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna os detalhes do ativo no portfólio do usuário autenticado, incluindo saldo, métricas de investimento (preço médio, total investido) e performance.
 * @summary Get coin portfolio details
 */
export type getWalletPortfolioCoinResponse200 = {
  data: GetWalletPortfolioCoin200
  status: 200
}

export type getWalletPortfolioCoinResponse401 = {
  data: GetWalletPortfolioCoin401
  status: 401
}

export type getWalletPortfolioCoinResponse404 = {
  data: GetWalletPortfolioCoin404
  status: 404
}

export type getWalletPortfolioCoinResponseSuccess = (getWalletPortfolioCoinResponse200) & {
  headers: Headers;
};
export type getWalletPortfolioCoinResponseError = (getWalletPortfolioCoinResponse401 | getWalletPortfolioCoinResponse404) & {
  headers: Headers;
};

export type getWalletPortfolioCoinResponse = (getWalletPortfolioCoinResponseSuccess | getWalletPortfolioCoinResponseError)

export const getGetWalletPortfolioCoinUrl = (coin: string,) => {


  

  return `https://api.wedofi.com/wallet/portfolio/${coin}`
}

export const getWalletPortfolioCoin = async (coin: string, options?: RequestInit): Promise<getWalletPortfolioCoinResponse> => {
  
  return customFetch<getWalletPortfolioCoinResponse>(getGetWalletPortfolioCoinUrl(coin),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Lista o histórico de operações da wallet do usuário autenticado com filtros por coin, product, side e período.
 * @summary List wallet history
 */
export type getWalletHistoryResponse200 = {
  data: GetWalletHistory200
  status: 200
}

export type getWalletHistoryResponse401 = {
  data: GetWalletHistory401
  status: 401
}

export type getWalletHistoryResponseSuccess = (getWalletHistoryResponse200) & {
  headers: Headers;
};
export type getWalletHistoryResponseError = (getWalletHistoryResponse401) & {
  headers: Headers;
};

export type getWalletHistoryResponse = (getWalletHistoryResponseSuccess | getWalletHistoryResponseError)

export const getGetWalletHistoryUrl = (params?: GetWalletHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://api.wedofi.com/wallet/history?${stringifiedParams}` : `https://api.wedofi.com/wallet/history`
}

export const getWalletHistory = async (params?: GetWalletHistoryParams, options?: RequestInit): Promise<getWalletHistoryResponse> => {
  
  return customFetch<getWalletHistoryResponse>(getGetWalletHistoryUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retorna os detalhes completos de uma operação do histórico, incluindo timeline de status e campos específicos do produto.
 * @summary Get wallet history detail
 */
export type getWalletHistoryIdResponse200 = {
  data: GetWalletHistoryId200
  status: 200
}

export type getWalletHistoryIdResponse401 = {
  data: GetWalletHistoryId401
  status: 401
}

export type getWalletHistoryIdResponse404 = {
  data: GetWalletHistoryId404
  status: 404
}

export type getWalletHistoryIdResponseSuccess = (getWalletHistoryIdResponse200) & {
  headers: Headers;
};
export type getWalletHistoryIdResponseError = (getWalletHistoryIdResponse401 | getWalletHistoryIdResponse404) & {
  headers: Headers;
};

export type getWalletHistoryIdResponse = (getWalletHistoryIdResponseSuccess | getWalletHistoryIdResponseError)

export const getGetWalletHistoryIdUrl = (id: string,) => {


  

  return `https://api.wedofi.com/wallet/history/${id}`
}

export const getWalletHistoryId = async (id: string, options?: RequestInit): Promise<getWalletHistoryIdResponse> => {
  
  return customFetch<getWalletHistoryIdResponse>(getGetWalletHistoryIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

